import * as faceapi from 'face-api.js'

export const MATCH_THRESHOLD = 0.5 

let modelsPromise = null
export function ensureRecognitionModelsLoaded() {
    if (!modelsPromise) {
        modelsPromise = Promise.all([
            faceapi.nets.tinyFaceDetector.loadFromUri('/models'),
            faceapi.nets.faceLandmark68Net.loadFromUri('/models'),
            faceapi.nets.faceRecognitionNet.loadFromUri('/models'),
        ])
    }
    return modelsPromise
}

export async function getFaceDescriptor(mediaEl) {
    const result = await faceapi
        .detectSingleFace(mediaEl, new faceapi.TinyFaceDetectorOptions({ inputSize: 224, scoreThreshold: 0.5 }))
        .withFaceLandmarks()
        .withFaceDescriptor()
    if (!result) return null
    return {
        box: result.detection.box,         
        descriptor: Array.from(result.descriptor), 
    }
}

export function descriptorDistance(a, b) {
    return faceapi.euclideanDistance(new Float32Array(a), new Float32Array(b))
}

export function isSamePerson(a, b, threshold = MATCH_THRESHOLD) {
    if (!a || !b) return null 
    return descriptorDistance(a, b) <= threshold
}